import { websiteDomain } from "../../constants/domain";

export function getShareMessageForProfile(currentUsername, profileDetails) {
  const profileWebsiteUrl = websiteDomain + "/by/" + profileDetails.username;
  const shareableUrl = profileDetails.short_url_flutter || profileWebsiteUrl;
  const isCreator = profileDetails.is_creator || false;
  const isOwner = currentUsername === profileDetails.username;
  const hasFamily = false;
  const hasCategory =
    hasFamily && profileDetails.family_details[0]?.categories.length > 0;
  let familyChannelCategory = "";

  if (hasFamily && hasCategory) {
    familyChannelCategory =
      profileDetails.family_details[0]?.categories[0]?.display_name + " ";
  }

  let message = "";

  if (isCreator) {
    // If creator is sharing his own profile
    if (isOwner) {
      if (hasFamily) {
        message = `Explore my ${familyChannelCategory}channels on qoohoo!`;
      } else {
        message = "I'm excited to become a creator on qoohoo!";
      }
    } else {
      // Others sharing creator's profile
      const profileName = profileDetails.fullname || profileDetails.username;
      message = `Explore ${familyChannelCategory}channels by creator ${profileName} on qoohoo!`;
    }
  } else {
    // If profile is not creators
    if (isOwner) {
      message = "I invite you to join qoohoo. Check out my profile!";
    } else {
      message = "Check out this profile on qoohoo!";
    }
  }

  return [message, shareableUrl];
}
